import { PropsWithChildren, SyntheticEvent } from 'react';

export const Wrapper = ({ children, handleClick, isLast, isHighlighted }: PropsWithChildren<{handleClick(e: SyntheticEvent): void; isLast: boolean; isHighlighted?: boolean; }>) => (
  <button type="button" className={`
    w-full py-4 px-3 text-left border-b-gray-300 ${isLast ? '' : 'border-b'} cursor-pointer font-heading text-sm font-thin text-main-900
    ${isHighlighted ? 'bg-main-100 text-main-900 font-medium' : 'bg-transparent'}
  `} onClick={handleClick}>
    {children}
  </button>
)

export const ResultContent = ({ children }: PropsWithChildren<{}>) => (
  <span className="flex items-center gap-3">
    {children}
  </span>
);

export const WorkshopIcon = () => (
  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded bg-white text-main-500 shadow-icon-box" aria-hidden="true">
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M22 9L12 5L2 9L12 13L22 9V15" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 10.6V16A6 3 0 0 0 18 16V10.6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </span>
);
